var __WEBPACK_NAMESPACE_OBJECT__ = require("@stripe/react-stripe-js");